import React from 'react';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

export default function Emergency ({ guest }) {
	return (
		<div>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label>
						<TextTranslate name="user-full-name" fallback="Full Name" textOnly/>
					</label>
				</div>
				<div className="col-lg-8 col-12">
					<p>{guest.emergency_contact.first_name} {guest.emergency_contact.last_name}</p>
				</div>
			</div>
			<hr/>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="word-relationship" fallback="Relationship" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<p>{guest.emergency_contact.relationship}</p>
				</div>
			</div>
			<hr/>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="user-phone-number" fallback="Phone Number"/></label>
				</div>
				<div className="col-lg-8 col-12">
					<p>{guest.emergency_contact.phone}</p>
				</div>
			</div>
		</div>
	)
}